import * as React from "react";
import styles from "./index.module.css";
import Option from "../../Options";

const findError = (errors, id) => {
  const match = errors.find((i) => i.optionId === id);
  if (match) {
    return match.message;
  }
  return null;
};

const Type2 = ({
  tabs,
  cells,
  errors,
  errorRefs,
  addModifier,
  removeModifier,
  menuOptions,
  modifications,
}) => {
  return (
    <div className={styles.container} data-cy="itemDetail-tabs">
      {tabs.map((i, index) =>
        i.entities.map((option) => (
          <Option
            key={option.id}
            forwardRef={errorRefs.current[index]}
            type={cells.group}
            optionItemTypes={{
              default: cells.primary,
              selected: cells.primarySelected,
            }}
            parentOption={menuOptions[option.id]}
            {...menuOptions[option.id]}
            error={findError(errors, option.id)}
            selectedMods={modifications[option.id] || []}
            addModifier={addModifier}
            removeModifier={removeModifier}
          />
        )),
      )}
    </div>
  );
};

Type2.displayName = "TabType2";

export default Type2;
